import { StandardEvents } from '@shopify/events';

/**
 * Displays the number of items in the cart and keeps it in sync with cart updates.
 */
class CartCount extends HTMLElement {
  connectedCallback() {
    document.addEventListener(StandardEvents.cartLinesUpdate, this.#onCartUpdate);
    window.addEventListener('pageshow', this.#onPageShow);
  }

  disconnectedCallback() {
    document.removeEventListener(StandardEvents.cartLinesUpdate, this.#onCartUpdate);
    window.removeEventListener('pageshow', this.#onPageShow);
  }

  /** @param {number} count */
  #render(count) {
    this.textContent = String(count);
  }

  /** @param {Event & { promise?: Promise<{ cart?: { totalQuantity?: number }, detail?: { itemCount?: number } }> }} event */
  #onCartUpdate = (event) => {
    event.promise
      ?.then(({ cart, detail }) => this.#render(cart?.totalQuantity ?? detail?.itemCount ?? 0))
      .catch((error) => {
        if (error?.name !== 'AbortError') throw error;
      });
  };

  /** @param {PageTransitionEvent} event */
  #onPageShow = async (event) => {
    if (!event.persisted) return;

    const response = await fetch(`${this.dataset.cartUrl}.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) return;

    const cart = await response.json();
    this.#render(cart.item_count);
  };
}

if (!customElements.get('cart-count')) {
  customElements.define('cart-count', CartCount);
}
